import * as React from "react";

import { Card } from "../../../affinityUI/elements/card";
import { LayoutWrapper } from "../../../affinityUI/structures/layout";

import errorNotFound from "./assets/errorNotFound.svg";
import { ErrorView } from "./errorView";

export const ErrorNoPatient: React.FC = () => {
  return (
    <LayoutWrapper>
      <Card>
        <ErrorView heading="Patient not found" imgSrc={errorNotFound}>
          The patient you are looking for could not be found
        </ErrorView>
      </Card>
    </LayoutWrapper>
  );
};
